import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../../utils/toast";

function UploadAssessment({ onClose, user_id, year }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const onSubmit = (data) => {
    setGlobalLoading(true);
    const formData = new FormData();
    formData.append("userfile", data.userfile[0]);
    formData.append("user_id", user_id);
    formData.append("year", year);
    axios
      .post(`${API_BASE_URL}/performance/upload_assessment`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        toastr.success("File uploaded successfully");
        onClose(response.data);
      })
      .catch((error) => {
        setGlobalLoading(false);
        console.error("Error uploading file:", error);
        toastr.error("Error uploading file");
      })
      .finally(() => {
        setGlobalLoading(false);
      });
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-md add_contract_modal" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-header">
                <h4 className="modal-title">Upload Self Assessment</h4>
                <button
                  onClick={onClose}
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>

              <div className="modal-body row" style={{ textAlign: "left" }}>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">Assessment File * <span className="text-danger fs-10">PDF Only</span></label>
                      <input type="hidden" name="user_id" {...register("user_id")} value={user_id} />
                      <input type="hidden" name="year" {...register("year")} value={year} />
                      <input
                        type="file"
                        accept=".pdf"
                        {...register("userfile", { required: "required" })}
                        className={`form-control ${
                          errors.userfile && "is-invalid"
                        }`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  onClick={onClose}
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary ms-2">
                  Upload Assessment
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default UploadAssessment;
